import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { TenantService } from '../services/tenant.service';
import { AuthService } from '../services/auth.service';

export const tenantSetupGuard: CanActivateFn = (_route, state) => {
  const tenantService = inject(TenantService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const onSetupPage = state.url.startsWith('/setup/tenant');

  return tenantService.checkExists().pipe(
    map(exists => {
      // TEMP DIAGNOSTIC — remove once confirmed.
      console.debug('[setup-guard] tenant', {
        url: state.url, exists, onSetupPage, isSuper: authService.isSuperAdmin(),
      });

      if (exists && onSetupPage) return router.createUrlTree(['/home']);
      if (!exists && !onSetupPage && authService.isSuperAdmin()) return router.createUrlTree(['/setup/tenant']);
      return true;
    })
  );
};
